import React, { useState } from 'react';
import { Input, Form, Button, Popover, Tooltip } from 'antd';
import { USER_FEEDBACK } from '@src/utils/sensor/track';
import Icon from '@ant-design/icons';
import FeedbackIcon from '@icons/common/feedback.svg';
import { StyledFloatButton, StyledRate } from './styled';
import apptracker from '@utils/sensor/apptracker';

const FeedbackForm = ({ onSubmit }) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    // TODO: santize values?
    apptracker(USER_FEEDBACK, values);
    onSubmit();
  };

  return (
    <div style={{ width: 400 }}>
      <Form initialValues={{ comment: '' }} onFinish={onFinish} form={form} name="feeback-form">
        <Form.Item name="rate" rules={[{ required: true, message: 'Please select a rating' }]}>
          <StyledRate allowHalf />
        </Form.Item>

        <Form.Item
          name="comment"
          rules={[{ required: true, message: 'Please enter your feedback' }]}
        >
          <Input.TextArea showCount maxLength={150} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

function Feedback() {
  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
  };

  const handleOpenChange = (value: boolean) => {
    setOpen(value);
  };

  return (
    <Popover
      placement="topRight"
      title="Share your feedback"
      content={<FeedbackForm onSubmit={onClose} />}
      trigger="click"
      onOpenChange={handleOpenChange}
      open={open}
      destroyTooltipOnHide={true}
    >
      <Tooltip title="Feedback" placement="left">
        <StyledFloatButton shape="circle" type="primary" icon={<Icon component={FeedbackIcon} />} />
      </Tooltip>
    </Popover>
  );
}

export default Feedback;
